import {createAsyncThunk} from '@reduxjs/toolkit';
import campaignsApi from 'common/src/modules/campaigns/campaigns.api';
import {setCampaigns, setCampaignStepsInformation} from '../campaignsLibrary.slice';
import {CampaignType, SlimCampaign} from 'common/src/modules/campaigns/campaigns.types';
import isFlagEnabled from 'common/src/modules/featureFlags/utils/isFlagEnabled';
import {FeatureFlagKey} from 'common/src/modules/featureFlags/featureFlags.types';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {handleApiError} from 'common/src/modules/errorHandling/handleApiError';

const fetchCampaigns = createAsyncThunk(
  `${BreadcrumbName.CampaignsLibrary}/fetchCampaigns`,
  async (_, {dispatch}) => {
    try {
      const campaigns: SlimCampaign[] = await campaignsApi.getSlimCampaigns();
      const enableLinkedin = isFlagEnabled(FeatureFlagKey.EnableLinkedinCampaign);
      const isCollaborationBadgesEnabled = isFlagEnabled(
        FeatureFlagKey.EnableCampaignCollaborationBadges,
      );
      const filteredCampaigns = enableLinkedin
        ? campaigns
        : campaigns.filter((campaign) => campaign.type !== CampaignType.LinkedInAds);
      dispatch(setCampaigns(filteredCampaigns));

      if (isCollaborationBadgesEnabled) {
        const collaborationBadgesData = await campaignsApi.fetchCollaborationBadgesData(
          filteredCampaigns.map((campaign) => campaign.id),
        );
        dispatch(setCampaignStepsInformation(collaborationBadgesData));
      }
    } catch (error) {
      handleApiError(error);
    }
  },
);

export default fetchCampaigns;
